import { useTranslation } from 'react-i18next';
import { useRootSelector } from '../../../../../../store/hooks';
import { selectSitePricingProductsData } from '../../../../store/features/products';
import { MuiStack } from '../../../../../../modules/material';
import Heading from '../../../../shared/components/Heading';
import VirtualVatField from './VirtualVatField';

export default function VirtualVatForm() {
  const { t } = useTranslation();
  const { vatForm: { vatInputs = [] } = {} } = useRootSelector(
    selectSitePricingProductsData,
  );

  if (vatInputs.length === 0) {
    return null;
  }

  return (
    <div className="informa-payment-virtual-vat-form">
      <Heading variant="h5" paletteColorName="brandSecondary" gutterBottom>
        {t('site.pricing.products-selection.form.virtual-vat.heading')}
      </Heading>

      <MuiStack spacing={1}>
        {vatInputs.map((input) => (
          <VirtualVatField field={input} key={input.name} />
        ))}
      </MuiStack>
    </div>
  );
}
